import { useQuery } from '@tanstack/react-query';

import { organizationsApi } from '../api/organizations-api';

import { organizationKeys } from './organization-keys';

/** Counts are computed live on the backend; a minute of staleness is plenty for a usage card. */
export function useOrganizationUsage(organizationId: string) {
  return useQuery({
    queryKey: organizationKeys.usage(organizationId),
    queryFn: () => organizationsApi.usage(organizationId),
    staleTime: 60_000,
  });
}
